import { ImageList, ImageListItem, Stack, Typography } from '@mui/material';
import ShowContainer from '../../../../components/material-ui/ShowContainer';
import { useTranslation } from 'react-i18next';
import useColor from '../../../../hooks/site/useColor';

export default function FSInfoString({ company, minDeposit, maxDeposit, isPictureGame, isColumn }) {
  const { t } = useTranslation();
  const { info } = useColor();

  const deposit =
    minDeposit || maxDeposit
      ? `${t('deposit')}: ${minDeposit || 0} - ${maxDeposit || ''} ${company.currency}`
      : '';

  const GameRow = ({ game }) => (
    <span>
      {game.name}{' '}
      <span style={{ color: info.main }} color="info">
        ({game.provider})
      </span>{' '}
      {`${game.freespins} FS, ${game.bet.totalBet} bet, w${game.wager}, co${game.cashout};`}
    </span>
  );

  return (
    <Typography variant="body1" color="textPrimary">
      {t('Template')}: #{company.name} {deposit ? `( ${deposit} ); ` : ''}
      <ShowContainer condition={isPictureGame}>
        <ImageList sx={{ width: 84 * 4, height: 84 }} cols={4} gap={8} rowHeight={84}>
          {Object.values(company.games).map((game) => (
            <ImageListItem key={game.image}>
              <img src={game.image} style={{ maxWidth: 84, maxHeight: 84 }} />
            </ImageListItem>
          ))}
        </ImageList>
      </ShowContainer>
      {isColumn ? (
        <Stack display={'flex'} gap={0.5} flexDirection={'column'}>
          {Object.values(company.games).map((game, indx) => (
            <GameRow key={indx} game={game} />
          ))}
        </Stack>
      ) : (
        Object.values(company.games).map((game, indx) => <GameRow key={indx} game={game} />)
      )}
    </Typography>
  );
}
